import React, { useEffect, useState } from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import { Grid } from "@mui/material";
import { cardLinkIcon, delIcon, editIcon } from "../assets";
import "react-toastify/dist/ReactToastify.css";
import { Link } from "react-router-dom";

function DashboardCards() {
  const [mixedData, setMixedData] = useState([]);
  const [visibleCards, setVisibleCards] = useState(27);
  const [isLoading, setIsLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");

  const handleLoadMore = () => {
    setIsLoading(true);
    setVisibleCards(visibleCards + 6);
    setTimeout(() => {
      setIsLoading(false);
    }, 3000);
  };

  useEffect(() => {
    axios
      .get("https://devuse-fullstack.vercel.app/tools/all-tools")
      .then((response) => {
        const combinedData = response.data;
        setMixedData(combinedData);
        setIsLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });

    const loadingTimer = setTimeout(() => {
      setIsLoading(false);
    }, 3000);
    return () => clearTimeout(loadingTimer);
  }, []);

  const handleDeleteTool = async (toolId) => {
    try {
      const url = `https://devuse-fullstack.vercel.app/tools/remove/${toolId}`;
      const response = await axios.delete(url);

      toast.success("Tool removed successfully");
    } catch (error) {
      toast.error("An unexpected error occurred while removing the tool.");
    }
  };

  const filteredData = mixedData.filter((item) =>
    item.toolTitle.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const reversedData = [...filteredData].reverse();

  return (
    <div>
      <ToastContainer />
      <div>
        <Grid container justifyContent={"center"} gap={2}>
          <Grid item lg={11}>
            <input
              className="search-bar"
              type="text"
              placeholder="search tool"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </Grid>
          <>
            {reversedData.length > 0 ? (
              <>
                {reversedData.slice(0, visibleCards).map((item, index) => (
                  <Grid
                    xs={10}
                    sm={4.9}
                    md={4.2}
                    lg={3.5}
                    key={index}
                    sx={{ pt: { xs: 3, md: 6 } }}
                  >
                    <div className="card" key={index}>
                      <div className="dashboard-card">
                        <div className="action-btn">
                          <Link to={`/dashboard/tool/edit/${item._id}`}>
                            <img src={editIcon} alt="" />
                          </Link>
                          <div>
                            <img
                              src={delIcon}
                              onClick={() => {
                                handleDeleteTool(item._id);
                              }}
                              alt=""
                            />
                          </div>
                        </div>
                      </div>
                      <div className="card_img_container">
                        <img src={item.backgroundImageUrl} alt="tools" />
                      </div>
                      <div className="card_content_container">
                        <div className="tag">
                          <div className="tag_width">
                            <span>{item.toolTag}</span>
                          </div>
                        </div>
                        <a
                          href={item.toolLink}
                          target="_blank"
                          rel="noreferrer"
                        >
                          <div className="card_link_container">
                            <h1>{item.toolTitle}</h1>
                            <img
                              src={cardLinkIcon}
                              className="link_image"
                              alt="link-icon"
                            />
                          </div>
                        </a>
                        <p>{item.toolDescription}</p>
                      </div>
                    </div>
                  </Grid>
                ))}
              </>
            ) : (
              <></>
            )}
          </>
        </Grid>
        {visibleCards < mixedData.length && (
          <Grid
            container
            justifyContent={"center"}
            alignItems={"center"}
            mt={5}
            sx={{ mb: { xs: 4, md: 0 } }}
          >
            <Grid
              item
              xs={12}
              md={9}
              lg={9}
              mt={5}
              className="postion-relative"
            >
              <button onClick={handleLoadMore}>
                <p></p>
                <svg
                  stroke-width="4"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  fill="none"
                  class="h-6 w-6"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M14 5l7 7m0 0l-7 7m7-7H3"
                    stroke-linejoin="round"
                    stroke-linecap="round"
                  ></path>
                </svg>
              </button>
            </Grid>
          </Grid>
        )}
      </div>
    </div>
  );
}

export default DashboardCards;
